import React, {useState,useEffect} from 'react';
import {HashRouter as Router} from "react-router-dom";
import {ConfigProvider,theme,Layout  } from "antd";
import { useSelector,useDispatch } from 'react-redux';
import {setAllContextMeta} from './store/modules/user'
import {getAllContextMeta} from './api/other'
import HeaderApp from './commh5/head'
import FooterApp from './commh5/footer'
import HomeApp from './pagesh5/Home/Index'
import TranslateApp from './pagesh5/Home/Translate'
import ErrorCorrectionApp from './pagesh5/Home/ErrorCorrection'
import AnalysisApp from './pagesh5/Home/Analysis'
import ChatApp from './pagesh5/Home/Chat'
import BuyMoreApp from './pagesh5/Home/BuyMore'
import './H5App.css';
const { Header, Sider, Content, Footer } = Layout;
const H5App = ()=>{
    const [themeVlue, setThemeVlue] = useState(localStorage.getItem('ai-chat-theme')||'default');
    const [clearContent,setClearContent] = useState(false)
    const handleChangeTheme = ()=>{
        if(localStorage.getItem('ai-chat-theme')==='dark'){
            localStorage.setItem('ai-chat-theme','default')
            setThemeVlue('default')
        }else{
            localStorage.setItem('ai-chat-theme','dark')
            setThemeVlue('dark')
        }
    }
    const appStyle = {
        backgroundColor: themeVlue==='default'?'#fff':'#2c2c2c',
        padding:'0'
    }
    const [collapsedLeft, setCollapsedLeft] = useState(false);
    const [collapsedRight, setCollapsedRight] = useState(false);
    const [homePageIndex,setHomePageIndex] = useState(localStorage.getItem('ai-chat-homePageIndex')?parseInt(localStorage.getItem('ai-chat-homePageIndex')):0);
    //超话
    const [sendTxt,setSendTxt] = useState(null)
    const handleSend = (v)=>{
        setSendTxt(v)
    }
    const {userInfo,allContextMeta} = useSelector(state=>state.user)
    const dispatch = useDispatch()

    useEffect(()=>{
        if(userInfo&&!allContextMeta){
            getAllContextMetas()
        }
    },[])
    //所有语境
    const getAllContextMetas =()=>{
        getAllContextMeta().then(res=>{
            if(res.code === 200){
                dispatch(setAllContextMeta(res.data))
            }
        })
    }
    return (
        <Router>
            <ConfigProvider
                theme={{components: { Input: {activeBorderColor:'#88993d',hoverBorderColor:'#88993d' }},
                    algorithm:themeVlue==='dark'?theme.darkAlgorithm:theme.defaultAlgorithm}}>
                <div className="App" style={appStyle}>
                    <Layout style={appStyle}>
                        <Layout>
                            <Header style={appStyle} >
                                <HeaderApp collapsedRight={collapsedRight} setCollapsedRight={setCollapsedRight}
                                           collapsedLeft={collapsedLeft} setCollapsedLeft={setCollapsedLeft}
                                           homePageIndex={homePageIndex} setHomePageIndex={setHomePageIndex}
                                           setClearContent={setClearContent} themeVlue={themeVlue} setThemeVlue={setThemeVlue}/>
                            </Header>
                            <Content style={appStyle} >
								{
								    homePageIndex===0?
								        <HomeApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
								        (
								            homePageIndex===1?
								                <TranslateApp setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
								                (
								                    homePageIndex===2?
								                        <ErrorCorrectionApp setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
								                        (
								                            homePageIndex===3?
								                                <AnalysisApp setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
								                                (
																	homePageIndex===4?
																		<ChatApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
																		<BuyMoreApp />
																)
								                        )
								                )
								    
								        )
								}
                            </Content>
                            {
                                homePageIndex===9?'':
                                    <Footer style={appStyle}>
                                        <FooterApp themeVlue={themeVlue} homePageIndex={homePageIndex} handleSend={handleSend}/>
                                    </Footer>
                            }
                        </Layout>
                    </Layout>
                </div>
            </ConfigProvider>
        </Router>
    );
}
export default H5App
